(() => {
  'use strict';
  function selectedPartner() {
    const params = new URLSearchParams(location.search);
    const intent = window.FlorameDeliveryIntent?.get?.();
    // A selected intent is one identity; never combine it with a stale URL slug.
    const selected = intent?.partnerId || intent?.partnerSlug ? intent : { partnerId: params.get('partnerId'), partnerSlug: params.get('partner') || params.get('partnerSlug') };
    return { id: String(selected.partnerId || ''), slug: String(selected.partnerSlug || '').toLowerCase() };
  }
  function boot() {
    document.querySelectorAll('[data-real-photo-gallery]').forEach(config => {
      if (config.dataset.ready) return;
      let photos; try { photos = JSON.parse(config.textContent || '[]'); } catch { return; }
      if (!Array.isArray(photos)) return;
      photos = photos.filter(photo => photo && typeof photo === 'object' && photo.mediaId);
      if (!photos.length) return;
      const section = config.closest('[id^="MainProduct-"]');
      const gallery = section?.querySelector('media-gallery');
      if (!gallery) return;
      config.dataset.ready = 'true';
      const lifecycle = new AbortController();
      const byId = new Map(photos.map(photo => [String(photo.mediaId), photo]));
      const viewer = gallery.querySelector('[id^="Slider-Gallery-"]');
      const thumbs = gallery.querySelector('[id^="Slider-Thumbnails-"]');
      const base = [...(viewer?.children || [])];
      const thumbBase = [...(thumbs?.children || [])];
      const mediaKey = element => String(element.dataset.mediaId || element.dataset.target || '').split('-').at(-1);
      function prioritize() {
        const partner = selectedPartner();
        const score = element => {
          const photo = byId.get(mediaKey(element));
          if (!photo) return 0;
          return (partner.id ? partner.id === String(photo.partnerId) : partner.slug && partner.slug === String(photo.partnerSlug).toLowerCase()) ? 1 : 2;
        };
        // Stable sort leaves every original/AI image ahead of real photographs.
        base.slice().sort((a, b) => score(a) - score(b)).forEach(element => viewer.append(element));
        thumbBase.slice().sort((a, b) => score(a) - score(b)).forEach((element, index) => { thumbs.append(element); element.dataset.mediaPosition = String(index + 1); });
        gallery.elements?.viewer?.resetPages?.(); gallery.elements?.thumbnails?.resetPages?.();
      }
      prioritize();
      ['florame:delivery-intent-changed', 'florame:delivery-intent-ready', 'florame:partner-ready', 'florame:partner-refreshed'].forEach(name => document.addEventListener(name, prioritize, { signal: lifecycle.signal }));
      // Dawn moves ProductModal under body when its custom element upgrades.
      const modal = section.querySelector('product-modal') || document.getElementById(section.id.replace(/^MainProduct-/, 'ProductModal-'));
      let observer;
      if (modal) {
        const badge = document.createElement('div'); badge.className = 'florame-real-photo-badge'; badge.hidden = true;
        const title = document.createElement('strong'), attribution = document.createElement('span');
        title.textContent = 'Foto reale verificata'; badge.append(title, attribution); modal.querySelector('[role="dialog"]')?.append(badge);
        const updateBadge = () => {
          const active = modal.querySelector('[data-media-id].active');
          const photo = active ? byId.get(String(active.dataset.mediaId).split('-').at(-1)) : null;
          badge.hidden = !photo; attribution.textContent = photo ? `Realizzato da ${photo.partnerName}` : '';
        };
        const content = modal.querySelector('[role="document"]');
        updateBadge();
        if (content) { observer = new MutationObserver(updateBadge); observer.observe(content, { subtree: true, attributes: true, attributeFilter: ['class'] }); }
      }
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(config)) return;
        lifecycle.abort(); observer?.disconnect(); delete config.dataset.ready;
        modal?.querySelector('.florame-real-photo-badge')?.remove();
      }, { signal: lifecycle.signal });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
